<div class="margin-auto d-flex justify-content-center align-content-center">

  <h1>You are not authorized</h1>
  
</div>